module.exports = __webpack_public_path__ + "files/5d6630b11aa15c3f09a4ba17f28ee943.png";